import { jsx as i } from "react/jsx-runtime";
import l from "@mui/material/SvgIcon";
import * as o from "react";
import { forwardRef as m } from "react";
const c = (e) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "5 5 22 22", ...e }, /* @__PURE__ */ o.createElement("path", { fill: "currentColor", d: "m6.908 23.768 6.198-6.198c.349-.349.928-.335 1.294.03.365.366.38.945.03 1.294l-6.198 6.198 3.28.079a.97.97 0 0 1 .936.936.863.863 0 0 1-.892.893l-5.488-.131a.97.97 0 0 1-.936-.937L5 20.444a.863.863 0 0 1 .893-.892.97.97 0 0 1 .936.936zM25.092 8.233l-6.198 6.198c-.349.348-.928.334-1.294-.031-.365-.366-.38-.945-.03-1.294l6.198-6.198-3.28-.079a.97.97 0 0 1-.936-.936.863.863 0 0 1 .892-.893l5.488.132a.97.97 0 0 1 .936.936L27 11.556a.863.863 0 0 1-.893.893.97.97 0 0 1-.936-.937z" })), f = /* @__PURE__ */ m(({ size: e = "inherit", sx: t, ...r }, n) => {
  const a = typeof t == "function" ? t : {
    fontSize: e,
    ...t
  };
  return /* @__PURE__ */ i(l, {
    ...r,
    ref: n,
    component: c,
    inheritViewBox: !0,
    sx: a
  });
});
f.displayName = "svg_enlarge";
export {
  f as default
};
